module.exports = __webpack_public_path__ + "static/img/4.5ce8d9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/sp/4.png
// module id = dj+Q
// module chunks = 0